const initialState = {
  type: null,
  message: null,
};

const toastReducers = (state = initialState, action) => {
  switch (action.type) {
    case "TOAST_SUCCESS":
      return { ...state, message: action.payload };
    default:
      return state;
  }
};

export default toastReducers;
